/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Col,
} from 'antd';
import { useTranslation } from 'react-i18next';
import {
  FormItem,
  FormInput,
  ItemLabel,
} from './Forms';
import { Field } from '../types';

const EIN = () => {
  const { t } = useTranslation();
  return (
    <>
      <Col span={1} />
      <Col span={19}>
        <FormItem
          marginBottom="-18px"
          style={{
            width: '100%',
            display: 'block',
            marginBottom: '0px',
          }}
          labelCol={{ span: 24 }}
          label={<ItemLabel>{t('FORM_FILL_COMPANY.COMPANY_EIN_TIN_HEADER')}</ItemLabel>}
          name={Field.VAT_NUMBER}
          rules={[
            {
              validator(_, value) {
                const regex = /^\d{2}-?\d{7}$/;
                if (value.replace(/[^0-9]/g, '').length !== 9) {
                  return Promise.reject(
                    new Error(t('FORM_FILL_COMPANY.COMPANY_EIN_TIN_9_DIGITS_LONG')),
                  );
                }
                return regex.test(value) ? Promise.resolve() : Promise.reject(
                  new Error(t('FORM_FILL_COMPANY.COMPANY_EIN_TIN_VALIDATION')),
                );
              },
            },
          ]}
        >
          <FormInput
            placeholder={t('FORM_FILL_COMPANY.COMPANY_EIN_TIN_MASK')}
          />
        </FormItem>
      </Col>
      <Col span={4} />
    </>
  );
};

export default EIN;
